import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import "react";
const WoozyEmoji = ()=>{
    const $ = c(27);
    let t0;
    let t1;
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ jsx("path", {
            d: "M16.1816 27.2656C22.3948 27.2656 27.4316 22.2288 27.4316 16.0156C27.4316 9.80242 22.3948 4.76562 16.1816 4.76562C9.96844 4.76562 4.93164 9.80242 4.93164 16.0156C4.93164 22.2288 9.96844 27.2656 16.1816 27.2656Z",
            fill: "url(#paint0_radial_10778_914)"
        });
        t1 = /*#__PURE__*/ jsx("path", {
            d: "M16.1816 27.2656C22.3948 27.2656 27.4316 22.2288 27.4316 16.0156C27.4316 9.80242 22.3948 4.76562 16.1816 4.76562C9.96844 4.76562 4.93164 9.80242 4.93164 16.0156C4.93164 22.2288 9.96844 27.2656 16.1816 27.2656Z",
            fill: "url(#paint1_radial_10778_914)"
        });
        t2 = /*#__PURE__*/ jsx("path", {
            d: "M16.1875 27.2346C22.4007 27.2346 27.4375 22.1978 27.4375 15.9846C27.4375 9.77142 22.4007 4.73462 16.1875 4.73462C9.9743 4.73462 4.9375 9.77142 4.9375 15.9846C4.9375 22.1978 9.9743 27.2346 16.1875 27.2346Z",
            fill: "url(#paint2_radial_10778_914)",
            fillOpacity: "0.8"
        });
        t3 = /*#__PURE__*/ jsx("path", {
            d: "M16.1875 4.73462C9.9743 4.73462 4.9375 9.77141 4.9375 15.9846C4.9375 22.1978 9.9743 27.2346 16.1875 27.2346C22.4007 27.2346 27.4375 22.1978 27.4375 15.9846C27.4375 9.77142 22.4007 4.73462 16.1875 4.73462Z",
            fill: "url(#paint3_radial_10778_914)",
            fillOpacity: "0.8"
        });
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
    } else {
        t0 = $[0];
        t1 = $[1];
        t2 = $[2];
        t3 = $[3];
    }
    let t10;
    let t11;
    let t12;
    let t13;
    let t14;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ jsx("g", {
            opacity: "0.4",
            filter: "url(#filter0_f_10778_914)",
            children: /*#__PURE__*/ jsx("path", {
                d: "M21.9628 8.4355C21.9628 10.0506 19.3972 11.3599 16.2324 11.3599C13.0675 11.3599 10.502 10.0506 10.502 8.4355C10.502 6.8204 13.0675 5.51111 16.2324 5.51111C19.3972 5.51111 21.9628 6.8204 21.9628 8.4355Z",
                fill: "url(#paint4_radial_10778_914)"
            })
        });
        t5 = /*#__PURE__*/ jsx("path", {
            d: "M12.052 16.6724C13.0013 19.0621 12.3498 21.6869 10.5967 22.5351C8.84358 23.3833 6.65278 22.1337 5.70339 19.7441C4.754 17.3544 5.40555 14.7296 7.15866 13.8814C8.91177 13.0332 11.1026 14.2828 12.052 16.6724Z",
            fill: "url(#paint5_radial_10778_914)"
        });
        t6 = /*#__PURE__*/ jsx("path", {
            d: "M19.948 16.6724C18.9987 19.0621 19.6502 21.6869 21.4033 22.5351C23.1564 23.3833 25.3472 22.1337 26.2966 19.7441C27.246 17.3544 26.5944 14.7296 24.8413 13.8814C23.0882 13.0332 20.8974 14.2828 19.948 16.6724Z",
            fill: "url(#paint6_radial_10778_914)"
        });
        t7 = /*#__PURE__*/ jsx("path", {
            d: "M18.2754 14.5978C18.2754 15.5382 18.8499 16.3005 19.5586 16.3005C20.2673 16.3005 20.8418 15.5382 20.8418 14.5978C20.8418 13.6574 20.2673 12.895 19.5586 12.895C18.8499 12.895 18.2754 13.6574 18.2754 14.5978Z",
            fill: "#421D30"
        });
        t8 = /*#__PURE__*/ jsx("path", {
            d: "M13.4208 14.462C13.5578 14.4103 13.6946 14.4012 13.8187 14.44C13.9429 14.479 14.0392 14.5615 14.1022 14.6649C14.2262 14.8691 14.2186 15.1466 14.0856 15.3876C13.8725 15.7735 13.3313 16.3604 12.2265 16.5006C11.1168 16.6413 10.2664 16.1093 9.98606 15.8724C9.8896 15.7909 9.81134 15.6995 9.75905 15.6039C9.70755 15.5096 9.67535 15.3983 9.69305 15.2855C9.71203 15.165 9.78402 15.0674 9.89203 15.0072C9.99379 14.9506 10.1202 14.9299 10.2578 14.9342C10.7314 14.9491 11.4151 14.9592 11.9748 14.8502C12.6143 14.7256 12.8585 14.674 13.4208 14.462Z",
            fill: "#421D30",
            stroke: "url(#paint7_linear_10778_914)",
            strokeWidth: "0.375"
        });
        t9 = /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.3401 15.9888C18.6178 16.3573 19.0415 16.6355 19.5586 16.6355C20.0756 16.6355 20.4994 16.3573 20.777 15.9888C21.0562 15.6183 21.2168 15.1255 21.2168 14.5978C21.2168 14.07 21.0562 13.5772 20.777 13.2067C20.4994 12.8382 20.0756 12.5601 19.5586 12.5601C19.0415 12.5601 18.6178 12.8382 18.3401 13.2067C18.0609 13.5772 17.9004 14.07 17.9004 14.5978C17.9004 15.1255 18.0609 15.6183 18.3401 15.9888ZM19.5586 16.3005C18.8499 16.3005 18.2754 15.5382 18.2754 14.5978C18.2754 13.6574 18.8499 12.895 19.5586 12.895C20.2673 12.895 20.8418 13.6574 20.8418 14.5978C20.8418 15.5382 20.2673 16.3005 19.5586 16.3005Z",
            fill: "url(#paint8_linear_10778_914)"
        });
        t10 = /*#__PURE__*/ jsx("path", {
            d: "M12.2033 12.9174C13.0232 12.444 13.4409 11.91 13.5548 11.4689C13.5987 11.2971 13.5471 11.1203 13.4181 11.0049C13.3724 10.9641 13.307 10.9311 13.2369 10.9081C13.0163 10.8355 12.831 10.9861 12.6883 11.1588C12.0268 11.9588 11.3712 12.4507 10.3361 12.8043C10.066 12.8969 9.44255 12.9276 9.46234 13.1283C9.48214 13.3291 10.0386 13.4019 10.4197 13.3896C11.0106 13.3704 11.7202 13.1969 12.2045 12.9173L12.2033 12.9174Z",
            fill: "#5C3147"
        });
        t11 = /*#__PURE__*/ jsx("path", {
            d: "M20.4626 9.34308C19.5329 8.89788 18.806 8.831 18.3522 8.9741C18.1756 9.03016 18.0555 9.17103 18.0375 9.34471C18.0311 9.4062 18.0442 9.48036 18.0687 9.55306C18.1459 9.78201 18.3937 9.85879 18.6337 9.88703C19.7454 10.0179 20.5868 10.3119 21.5495 11.0072C21.801 11.1884 22.2231 11.7067 22.3842 11.5801C22.5453 11.4535 22.2552 10.9362 22.0027 10.6159C21.6112 10.1193 21.0109 9.60501 20.4618 9.34205L20.4626 9.34308Z",
            fill: "#5C3147"
        });
        t12 = /*#__PURE__*/ jsx("path", {
            d: "M22.3623 17.1892C22.5306 17.1752 22.6784 17.2577 22.7852 17.3923C22.8891 17.5235 22.9622 17.7105 23.0029 17.9431C23.1282 18.6586 22.9389 19.3675 22.5986 19.9617C22.2586 20.5553 21.7597 21.0486 21.2422 21.3347C20.1318 21.9485 19.1991 21.6762 18.3203 21.3054C17.4295 20.9295 16.6215 20.476 15.6436 20.5613C14.4007 20.6698 13.7341 20.9719 13.1582 21.199C12.8681 21.3134 12.5886 21.4135 12.2725 21.4529C11.9536 21.4926 11.607 21.4696 11.1758 21.3523C10.0873 21.0562 9.47423 20.2603 9.19238 19.5476C9.05196 19.1924 8.98977 18.8486 8.99414 18.5847C8.9963 18.4548 9.01531 18.3298 9.05957 18.2302C9.10298 18.1328 9.19553 18.0145 9.35645 18.0144L9.4502 18.0281C9.53563 18.0537 9.59871 18.1118 9.64258 18.1697C9.69856 18.2437 9.74191 18.3398 9.77832 18.4324C9.85776 18.6344 9.92157 18.8545 10.0391 19.1062C10.2621 19.584 10.6422 20.0861 11.502 20.2458C12.1497 20.3661 12.5744 20.136 13.1533 19.7957C13.7344 19.454 14.4405 19.0228 15.6006 18.8582C16.6677 18.7067 17.5279 18.8222 18.251 18.9607C18.618 19.031 18.9299 19.103 19.2334 19.1541C19.5317 19.2043 19.7971 19.2301 20.0459 19.2078C21.068 19.1159 21.6108 18.5801 21.749 17.9363C21.7929 17.7315 21.869 17.5576 21.9688 17.4285C22.0672 17.301 22.2016 17.2028 22.3623 17.1892Z",
            fill: "#421D30"
        });
        t13 = /*#__PURE__*/ jsx("path", {
            d: "M22.3623 17.1892C22.5306 17.1752 22.6784 17.2577 22.7852 17.3923C22.8891 17.5235 22.9622 17.7105 23.0029 17.9431C23.1282 18.6586 22.9389 19.3675 22.5986 19.9617C22.2586 20.5553 21.7597 21.0486 21.2422 21.3347C20.1318 21.9485 19.1991 21.6762 18.3203 21.3054C17.4295 20.9295 16.6215 20.476 15.6436 20.5613C14.4007 20.6698 13.7341 20.9719 13.1582 21.199C12.8681 21.3134 12.5886 21.4135 12.2725 21.4529C11.9536 21.4926 11.607 21.4696 11.1758 21.3523C10.0873 21.0562 9.47423 20.2603 9.19238 19.5476C9.05196 19.1924 8.98977 18.8486 8.99414 18.5847C8.9963 18.4548 9.01531 18.3298 9.05957 18.2302C9.10298 18.1328 9.19553 18.0145 9.35645 18.0144L9.4502 18.0281C9.53563 18.0537 9.59871 18.1118 9.64258 18.1697C9.69856 18.2437 9.74191 18.3398 9.77832 18.4324C9.85776 18.6344 9.92157 18.8545 10.0391 19.1062C10.2621 19.584 10.6422 20.0861 11.502 20.2458C12.1497 20.3661 12.5744 20.136 13.1533 19.7957C13.7344 19.454 14.4405 19.0228 15.6006 18.8582C16.6677 18.7067 17.5279 18.8222 18.251 18.9607C18.618 19.031 18.9299 19.103 19.2334 19.1541C19.5317 19.2043 19.7971 19.2301 20.0459 19.2078C21.068 19.1159 21.6108 18.5801 21.749 17.9363C21.7929 17.7315 21.869 17.5576 21.9688 17.4285C22.0672 17.301 22.2016 17.2028 22.3623 17.1892Z",
            stroke: "url(#paint9_linear_10778_914)",
            strokeWidth: "0.375"
        });
        t14 = /*#__PURE__*/ jsx("path", {
            d: "M22.3623 17.1892C22.5306 17.1752 22.6784 17.2577 22.7852 17.3923C22.8891 17.5235 22.9622 17.7105 23.0029 17.9431C23.1282 18.6586 22.9389 19.3675 22.5986 19.9617C22.2586 20.5553 21.7597 21.0486 21.2422 21.3347C20.1318 21.9485 19.1991 21.6762 18.3203 21.3054C17.4295 20.9295 16.6215 20.476 15.6436 20.5613C14.4007 20.6698 13.7341 20.9719 13.1582 21.199C12.8681 21.3134 12.5886 21.4135 12.2725 21.4529C11.9536 21.4926 11.607 21.4696 11.1758 21.3523C10.0873 21.0562 9.47423 20.2603 9.19238 19.5476C9.05196 19.1924 8.98977 18.8486 8.99414 18.5847C8.9963 18.4548 9.01531 18.3298 9.05957 18.2302C9.10298 18.1328 9.19553 18.0145 9.35645 18.0144L9.4502 18.0281C9.53563 18.0537 9.59871 18.1118 9.64258 18.1697C9.69856 18.2437 9.74191 18.3398 9.77832 18.4324C9.85776 18.6344 9.92157 18.8545 10.0391 19.1062C10.2621 19.584 10.6422 20.0861 11.502 20.2458C12.1497 20.3661 12.5744 20.136 13.1533 19.7957C13.7344 19.454 14.4405 19.0228 15.6006 18.8582C16.6677 18.7067 17.5279 18.8222 18.251 18.9607C18.618 19.031 18.9299 19.103 19.2334 19.1541C19.5317 19.2043 19.7971 19.2301 20.0459 19.2078C21.068 19.1159 21.6108 18.5801 21.749 17.9363C21.7929 17.7315 21.869 17.5576 21.9688 17.4285C22.0672 17.301 22.2016 17.2028 22.3623 17.1892Z",
            stroke: "url(#paint10_radial_10778_914)",
            strokeWidth: "0.375"
        });
        $[4] = t10;
        $[5] = t11;
        $[6] = t12;
        $[7] = t13;
        $[8] = t14;
        $[9] = t4;
        $[10] = t5;
        $[11] = t6;
        $[12] = t7;
        $[13] = t8;
        $[14] = t9;
    } else {
        t10 = $[4];
        t11 = $[5];
        t12 = $[6];
        t13 = $[7];
        t14 = $[8];
        t4 = $[9];
        t5 = $[10];
        t6 = $[11];
        t7 = $[12];
        t8 = $[13];
        t9 = $[14];
    }
    let t15;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = /*#__PURE__*/ jsxs("filter", {
            id: "filter0_f_10778_914",
            x: "7.66993",
            y: "2.67909",
            width: "17.125",
            height: "11.5129",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
                /*#__PURE__*/ jsx("feFlood", {
                    floodOpacity: "0",
                    result: "BackgroundImageFix"
                }),
                /*#__PURE__*/ jsx("feBlend", {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "BackgroundImageFix",
                    result: "shape"
                }),
                /*#__PURE__*/ jsx("feGaussianBlur", {
                    stdDeviation: "1.41601",
                    result: "effect1_foregroundBlur_10778_914"
                })
            ]
        });
        $[15] = t15;
    } else t15 = $[15];
    let t16;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint0_radial_10778_914",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(15.8517 6.11161) scale(21.0305)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FFF1B6"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.43",
                    stopColor: "#FFD400"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.7",
                    stopColor: "#FFD400"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FF8E00"
                })
            ]
        });
        $[16] = t16;
    } else t16 = $[16];
    let t17;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint1_radial_10778_914",
            cx: "0",
            cy: "0",
            r: "1",
            gradientTransform: "matrix(12.8919 18.2106 -18.2098 12.8488 11.0873 6.53491)",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.608798",
                    stopColor: "#FFE437",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.858784",
                    stopColor: "#FF79B1",
                    stopOpacity: "0.45"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.994222",
                    stopColor: "#FF3673",
                    stopOpacity: "0.56"
                })
            ]
        });
        $[17] = t17;
    } else t17 = $[17];
    let t18;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint2_radial_10778_914",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(16.1875 16.4969) rotate(-90) scale(12.3762 11.8236)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.848958",
                    stopColor: "#FFC60C",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FF7039",
                    stopOpacity: "0.68"
                })
            ]
        });
        $[18] = t18;
    } else t18 = $[18];
    let t19;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint3_radial_10778_914",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(16.1875 15.4723) rotate(90) scale(11.7623 11.6637)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.847356",
                    stopColor: "#FE789B",
                    stopOpacity: "0"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#F11414",
                    stopOpacity: "0.41"
                })
            ]
        });
        $[19] = t19;
    } else t19 = $[19];
    let t20;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t20 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint4_radial_10778_914",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(16.2324 8.4355) rotate(89.9999) scale(2.92439 5.37628)",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "white"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFED49",
                    stopOpacity: "0"
                })
            ]
        });
        $[20] = t20;
    } else t20 = $[20];
    let t21;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t21 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint5_radial_10778_914",
            cx: "0",
            cy: "0",
            r: "1",
            gradientTransform: "matrix(1.17987 4.98462 -3.64441 1.05054 8.87769 18.2083)",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "#FF6915"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFC60A",
                    stopOpacity: "0"
                })
            ]
        });
        $[21] = t21;
    } else t21 = $[21];
    let t22;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = /*#__PURE__*/ jsxs("radialGradient", {
            id: "paint6_radial_10778_914",
            cx: "0",
            cy: "0",
            r: "1",
            gradientTransform: "matrix(-0.955509 4.42514 3.23885 0.865527 23.1223 18.2083)",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.0407265",
                    stopColor: "#FF6915"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFD504",
                    stopOpacity: "0"
                })
            ]
        });
        $[22] = t22;
    } else t22 = $[22];
    let t23;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t23 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint7_linear_10778_914",
            x1: "11.6783",
            y1: "14.787",
            x2: "11.9882",
            y2: "16.4705",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.156098",
                    stopColor: "#FF9900"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFEAB4"
                })
            ]
        });
        $[23] = t23;
    } else t23 = $[23];
    let t24;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t24 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint8_linear_10778_914",
            x1: "19.5586",
            y1: "12.623",
            x2: "20.9881",
            y2: "15.4399",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.0345786",
                    stopColor: "#FD9E28"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFE39E"
                })
            ]
        });
        $[24] = t24;
    } else t24 = $[24];
    let t25;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t25 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint9_linear_10778_914",
            x1: "15.2772",
            y1: "17.9666",
            x2: "15.2772",
            y2: "21.4472",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.245009",
                    stopColor: "#F77600"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "0.673277",
                    stopColor: "#FF930E"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#FFCF53"
                })
            ]
        });
        $[25] = t25;
    } else t25 = $[25];
    let t26;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t26 = /*#__PURE__*/ jsxs("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t0,
                t1,
                t2,
                t3,
                t4,
                t5,
                t6,
                t7,
                t8,
                t9,
                t10,
                t11,
                t12,
                t13,
                t14,
                /*#__PURE__*/ jsxs("defs", {
                    children: [
                        t15,
                        t16,
                        t17,
                        t18,
                        t19,
                        t20,
                        t21,
                        t22,
                        t23,
                        t24,
                        t25,
                        /*#__PURE__*/ jsxs("radialGradient", {
                            id: "paint10_radial_10778_914",
                            cx: "0",
                            cy: "0",
                            r: "1",
                            gradientUnits: "userSpaceOnUse",
                            gradientTransform: "translate(16.0179 21.2609) rotate(90) scale(1.93506 8.58526)",
                            children: [
                                /*#__PURE__*/ jsx("stop", {
                                    stopColor: "#FFF0CA"
                                }),
                                /*#__PURE__*/ jsx("stop", {
                                    offset: "0.555515",
                                    stopColor: "#FFCC5D"
                                }),
                                /*#__PURE__*/ jsx("stop", {
                                    offset: "0.899323",
                                    stopColor: "#FEAA3D",
                                    stopOpacity: "0"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
        $[26] = t26;
    } else t26 = $[26];
    return t26;
};
export { WoozyEmoji };
